import { relations } from 'drizzle-orm'
import { boolean, pgTable, text } from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getNullableIdReference,
  getTimestampWithTimezone,
} from '../common/utils'
import { employees } from './employee'

export const emailAccounts = pgTable(
  'email_accounts',
  {
    ...getBaseFields(),
    email: text().notNull(),
    employeeId: getNullableIdReference(() => employees.id),
    provider: text().notNull().default('microsoft'),
    authType: text().notNull(), // 'client_credentials' | 'delegated'
    isActive: boolean().notNull().default(true),
    inboxDeltaLink: text(),
    sentDeltaLink: text(),
    lastSyncAt: getTimestampWithTimezone(),
    lastSyncError: text(),
  },
  (table) => getBaseIndexes('email_accounts', table),
)

export const emailAccountsRelations = relations(emailAccounts, ({ one }) => ({
  employee: one(employees, {
    fields: [emailAccounts.employeeId],
    references: [employees.id],
  }),
}))
